module.exports = __webpack_public_path__ + "static/1-38f73fa168f9590f4a2d15fa633f1291.jpg";